import { notification } from 'antd';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface NotifyProps {
	type: NotificationType;
	message: string;
	description: string;
	duration?: number;
	placement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
	key?: string;
}

let lastShownMessage = '';
let lastShownTimestamp = 0;

export const showNotification = ({
	type,
	message,
	description,
	duration = 5,
	placement = 'topRight',
	key,
}: NotifyProps) => {
	const now = Date.now();

	// Avoid showing the same message if it was shown less than 5s ago
	if (
		message === lastShownMessage &&
		now - lastShownTimestamp < 7000 // 7 seconds
	) {
		return;
	}

	lastShownMessage = message;
	lastShownTimestamp = now;

	notification[type]({
		message,
		description,
		placement,
		duration,
		key,
	});
};

export const destroyNotification = (key?: string) => {
	if (key) {
		notification.destroy(key);
	} else {
		notification.destroy();
	}
};